import { createApiRequest } from "@/lib/api/createApiService";
import { CARBON_INVENTORY_ENDPOINTS } from "./carbon-inventory.endpoints";
import { apiClient } from "@/lib/api";

export const carbonInventoryService = {
  getCarbonTargets: async (params = {}, options = {}) => {
    console.log("params", params);
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_TARGETS,
      method: "GET",
      body: params,
      ...options,
    });
  },

  saveCarbonTargets: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_TARGETS,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateCarbonTargets: async (id, payload = {}, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_TARGETS_UPDATE(id),
      method: "PATCH",
      body: payload,
      ...options,
    });
  },

  deleteCarbonTargetById: (id, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_TARGETS_DELETE(id),
      method: "DELETE",
      ...options,
    });
  },

  getCarbonTargetsList: async (params = {}, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_TARGET_LIST,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getCarbonTargetDetailsById: (id, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_TARGETS_DETAILS(id),
      method: "GET",
      ...options,
    });
  },

  getCarbonBankSubmission: (year, status, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_BANK_SUBMISSIONS(year, status),
      method: "GET",
      ...options,
    });
  },

  getCarbonBankSubmissionsDetails: (id, status, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_BANK_SUBMISSIONS_DETAILS(id),
      method: "GET",
      ...options,
    });
  },

  getCarbonBankOverview: (year, status, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_BANK_OVERVIEW(year, status),
      method: "GET",
      ...options,
    });
  },

  getCarbonSurvey: async (params = {}, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.GET_SURVEY,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getCarbonSurveyById: async (surveyId, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.GET_SURVEY_BY_ID(surveyId),
      method: "GET",
      ...options,
    });
  },

  createCarbonSurvey: async (payload, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CREATE_SURVEY,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateCarbonSurvey: async (surveyId, payload, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.UPDATE_SURVEY(surveyId),
      method: "PUT",
      body: payload,
      ...options,
    });
  },

  deleteCarbonSurvey: async (surveyId, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.DELETE_SURVEY(surveyId),
      method: "DELETE",
      ...options,
    });
  },

  reviewCarbonBankSubmissionsReview: async (payload, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_BANK_SUBMISSONS_REVIEW,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  uploadFile: async (companyId, formData) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_SURVEY_FILES(companyId),
      method: "POST",
      body: formData,
      isFormData: true,
    });
  },

  downloadFile: async (proof) => {
    if (!proof.fileId) return;
    const { data } = await apiClient.get(
      CARBON_INVENTORY_ENDPOINTS.CARBON_SUREY_FILES_DOWNLOAD(proof.fileId),
      { responseType: "blob" },
    );
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = proof.name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },

  deleteFiles: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: CARBON_INVENTORY_ENDPOINTS.CARBON_SUREY_FILES_DELETE,
      method: "POST",
      body: payload,
      ...options,
    });
  },
};
